import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import documentSignatureForm from "./modules/document-signature-form";
import signatureForm from "./modules/signature-form";

export default new Vuex.Store({
  modules: {
    documentSignatureForm,
    signatureForm,
  }
})
